module.exports = __webpack_public_path__ + "static/blind-soprano-shoots-for-the-moon-b67bfe79da48ad043e481761d4255186.jpg";